import { useEffect, useState } from 'react'
import { CarrouselCSS } from './CarrouselCSS.styled'
import { CONTENT_TYPES } from 'constants/games/contentTypes'

import { LVG_ASSETS } from 'constants/games/lvg/lvgAssets'
import { useLvgState } from 'hooks/games/lvg/useLvgState'
import { Link } from 'components/Atoms/Link'
import { useNavigate } from 'react-router-dom'
import { carrouselAssets } from './carrouselAssets'

const TOTAL_SLIDES = 3
const SLIDE_DURATION = 6000

export const Carrousel = () => {
  const navigateTo = useNavigate()
  const { setActiveAsset } = useLvgState()

  const [currentIndex, setCurrentIndex] = useState(0)
  const [isPaused, setIsPaused] = useState(false)

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (!isPaused) setCurrentIndex((prevIndex) => (prevIndex + 1) % TOTAL_SLIDES)
    }, SLIDE_DURATION)

    return () => {
      clearInterval(intervalId)
    }
  }, [isPaused])

  const goToSlide = (index) => {
    setCurrentIndex(index)
  }

  const handleSlideHover = () => {
    setIsPaused(true)
  }

  const handleSlideLeave = () => {
    setIsPaused(false)
  }

  const handleStocksClick = (e) => {
    e.stopPropagation()
    navigateTo(`/game/${CONTENT_TYPES.LVG_STOCKS}`)
  }

  const onSelectYoloCoaster = (e) => {
    e.preventDefault()
    const yolocoasterInfo = LVG_ASSETS.filter((asset) => asset.id === 'YOLOCOASTER').at(0)
    setActiveAsset(yolocoasterInfo, CONTENT_TYPES.LVG_CRYPTO)
  }

  return (
    <CarrouselCSS className='hero'>
      <div className='carousel-container' onMouseEnter={handleSlideHover} onMouseLeave={handleSlideLeave}>
        <div className='carousel my-carousel carousel--translate'>
          <input className='carousel__activator' type='radio' name='carousel' id='A' checked={currentIndex === 0} />
          <input className='carousel__activator' type='radio' name='carousel' id='B' checked={currentIndex === 1} />
          {/* <input className='carousel__activator' type='radio' name='carousel' id='C' checked={currentIndex === 2} /> */}
          <input className='carousel__activator' type='radio' name='carousel' id='D' checked={currentIndex === 2} />
          <div className='carousel__track'>
            {/* Slide 1 */}
            <li class="carousel__slide friendtech">
              <a href="https://yolorekt.finance/game/lvg-crypto">
                <div class="left">
                  <h1></h1>
                  <h2><strong>Friend.tech is live</strong>
                    <div class="yt_wrapper">Bid with 10x leverage on $FRIEND now
                    </div>
                  </h2>
                </div>
                <div class="right">
                  <img alt='friend' src={carrouselAssets.friend_tech_image} />
                </div>
              </a>
            </li> 
            {/* <li class='carousel__slide yolo_token'>
              <a href=' https://yolorekt.finance/presale' target='blank'>
                <div class='left'>
                  <h1></h1>
                  <h2>
                    <strong>$YOLO Presale is live</strong>
                    <div class='yt_wrapper'>
                      The YOLOREKT Token is now available for public presale.{' '}
                      <span class='fake_link'>Contribute now</span>
                    </div>
                  </h2>
                </div>
                <div class='right'></div>
              </a>
            </li> */}
            {/* Slide 2 */}
            <li className='carousel__slide yolobot'>
              <Link to='/yolobot' target='blank'>
                <div className='left'>
                  <h1></h1>
                  <h2>
                    <strong>NOW AVAILABLE</strong> The first-ever high-performance 1000x leveraged bidding bot on
                    Telegram, from YOLOREKT.
                  </h2>
                </div>
              </Link>
            </li>
            {/* Slide 3 */}
            {/* <li className='carousel__slide stocks_are_back'>
              <div className='slide-hover' onClick={handleStocksClick}>
                <div className='left'>
                  <h1>Stocks are back</h1>
                  <h2>
                    A new <strong>LEVERAGED SYNTHETIC STOCKS</strong> game with 1000x has been launched
                  </h2>
                </div>
                <div className='right'>
                  <div className='stocks_icons'>
                    <div className='asset_icon tsla'></div>
                    <div className='asset_icon spy'></div>
                    <div className='asset_icon amzn'></div>
                    <div className='asset_icon googl'></div>
                    <div className='asset_icon aapl'></div>
                    <div className='asset_icon nvda'></div>
                  </div>
                </div>
              </div>
            </li> */}
            {/* Slide 4 */}
            <li className='carousel__slide yolocoaster'>
              <div className='slide-hover' onClick={onSelectYoloCoaster}>
                <div className='left'>
                  <h1></h1>
                </div>
                <div className='right'>
                  <div className='checklist'>
                    <div className='bullet_wrap'>
                      <div className='bullet'>High constant volatility</div>
                      <div className='bullet'>Extremely high leverage</div>
                    </div>
                    <div className='bullet_wrap'>
                      <div className='bullet'>Adrenaline-powered degen fun</div>
                      <div className='bullet'>Ready for vomit-inducing profits</div>
                    </div>
                  </div>
                  <div className='pepecoaster'></div>
                </div>
              </div>
            </li>
          </div>

          <div className='carousel__indicators'>
            <label className='carousel__indicator' htmlFor='A' onClick={() => goToSlide(0)}></label>
            <label className='carousel__indicator' htmlFor='B' onClick={() => goToSlide(1)}></label>
            {/* <label className='carousel__indicator' htmlFor='C' onClick={() => goToSlide(2)}></label> */}
            <label className='carousel__indicator' htmlFor='D' onClick={() => goToSlide(2)}></label>
          </div>
        </div>
      </div>
    </CarrouselCSS>
  )
}
